import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { formatViews, formatDate } from '@/utils/format';

export default function FeaturedArticles() {
  const featured = articles
    .filter((a) => a.category === 'featured' || a.category === 'exclusive')
    .slice(0, 4);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              精品推荐
            </h2>
            <p className="text-sm text-foreground-500">编辑精选的优质内容，口碑佳作不容错过</p>
          </div>
          <Link
            to="/category/featured"
            className="whitespace-nowrap text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featured.map((article) => (
            <article key={article.id} className="group rounded-lg bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer" data-product-shop>
              <Link to={`/article/${article.id}`} className="block">
                <div className="relative w-full h-48 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={`${article.title} - 蜜桃传媒精品推荐`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2 py-0.5 rounded-md bg-primary-500/90 text-background-50 text-xs font-medium">
                      推荐
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 mb-3">{article.excerpt}</p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span>{formatDate(article.date)}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> {formatViews(article.views)}
                    </span>
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}